<template>
  <main>
    <div class="container-bokahem">
      <div class="calendar-bokahem mb-4">
        <div class="calendar-bokahem-body">
          <div>
            <div class="row-bokahem">
              <div class="col-bokahem-12">
                <fieldset class="form-group-bokahem check_border_bokahem">
                  
                  <div class="bokahem-field-name-block">
                    <span>Företagsnamn</span>
                    <span class="smartapresentkort-valid-error" v-if="submitted && !$v.seller.company_name.required">
                      krävs
                    </span>
                  </div>
                  <div class="info-input-bokahem-holder">
                    <input type="text" v-model="seller.company_name" placeholder="Företagsnamn" class="info-block-bokahem-input border-rounded-bokahem font-weight-medium-bokahem">
                  </div>

                  <div class="bokahem-field-name-block">
                    <span>Företagets e-post</span>
                    <span class="smartapresentkort-valid-error" v-if="submitted && !$v.seller.email.required">
                      krävs
                    </span>
                    <span class="smartapresentkort-valid-error" v-if="submitted && !$v.seller.email.email">
                      är inte giltig
                    </span>
                    <span class="smartapresentkort-valid-error" v-if="submitted && companyEmailApiError">
                      {{ companyEmailApiError }}
                    </span>
                  </div>
                  <div class="info-input-bokahem-holder mb-1">
                    <input type="text" v-model="seller.email" placeholder="Företagets e-post" class="info-block-bokahem-input border-rounded-bokahem font-weight-medium-bokahem">
                  </div>

                  <div class="bokahem-field-name-block">
                    <span>Företagstelefon</span>
                    <span class="smartapresentkort-valid-error" v-if="submitted && !$v.seller.phone.required">
                      krävs
                    </span>
                  </div>
                  <div class="info-input-bokahem-holder mb-1">
                    <input type="text" v-model="seller.phone" placeholder="Företagstelefon" class="info-block-bokahem-input border-rounded-bokahem font-weight-medium-bokahem">
                  </div>

                  <div class="bokahem-field-name-block">
                    <span>Organisationsnummer</span>
                    <span class="smartapresentkort-valid-error" v-if="submitted && !$v.seller.organisation_number.required">
                      krävs
                    </span>
                  </div>
                  <div class="info-input-bokahem-holder mb-1">
                    <input type="text" v-model="seller.organisation_number" placeholder="Organisationsnummer" class="info-block-bokahem-input border-rounded-bokahem font-weight-medium-bokahem">
                  </div>

                  <div class="bokahem-field-name-block">
                    <span>Företagets webbsida</span>
                    <span class="smartapresentkort-valid-error" v-if="submitted && !$v.seller.company_webpage.required">
                      krävs
                    </span>
                    <span class="smartapresentkort-valid-error" v-if="submitted && companyWebpageApiError">
                      {{ companyWebpageApiError }}
                    </span>
                  </div>
                  <div class="info-input-bokahem-holder mb-1">
                    <input type="text" v-model="seller.company_webpage" placeholder="Företagets webbsida" class="info-block-bokahem-input border-rounded-bokahem font-weight-medium-bokahem">
                  </div>

                  <div class="bokahem-field-name-block">
                    <span>BG Nummer</span>
                  </div>
                  <div class="info-input-bokahem-holder mb-1">
                    <input type="text" v-model="seller.bg_number" placeholder="BG Nummer" class="info-block-bokahem-input border-rounded-bokahem font-weight-medium-bokahem">
                  </div>


                  <div class="bokahem-field-name-block">
                    <span>Stad</span>
                  </div>
                  <div class="info-input-bokahem-holder mb-1">
                    <input type="text" v-model="seller.city" placeholder="Stad" class="info-block-bokahem-input border-rounded-bokahem font-weight-medium-bokahem">
                  </div>

                  <div class="bokahem-field-name-block">
                    <span>Kontaktpersonens förnamn</span>
                    <span class="smartapresentkort-valid-error" v-if="submitted && !$v.seller.contact_person_first_name.required">
                      krävs
                    </span>
                  </div>
                  <div class="info-input-bokahem-holder mb-1">
                    <input type="text" v-model="seller.contact_person_first_name" placeholder="Kontaktpersonens förnamn" class="info-block-bokahem-input border-rounded-bokahem font-weight-medium-bokahem">
                  </div>

                  <div class="bokahem-field-name-block">
                    <span>Kontaktpersons efternamn</span>
                    <span class="smartapresentkort-valid-error" v-if="submitted && !$v.seller.contact_person_last_name.required">
                      krävs
                    </span>
                  </div>
                  <div class="info-input-bokahem-holder mb-1">
                    <input type="text" v-model="seller.contact_person_last_name" placeholder="Kontaktpersonens efternamn" class="info-block-bokahem-input border-rounded-bokahem font-weight-medium-bokahem">
                  </div>

                </fieldset>
              </div>
              <div class="col-bokahem-12 mt-1">
                <button
                    @mouseover="hover = true"
                    @mouseleave="hover = false"
                    :class="{ 'btn-hover': hover }"
                    style="background-color: #328904 !important"
                    @click="sendForm()" class="btn-bokahem btn-bokahem-primary text-button-color text-white border-rounded-bokahem btn-bokahem-lg font-weight-semi-bokahem">
                  Skicka in
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>

import { SUBMIT_FORM } from "@/store/actions.type";
import { required, email } from 'vuelidate/lib/validators';

export default {
  data() {
    return {
      seller: {
        company_name: '',
        email: '',
        phone: '',
        organisation_number: '',
        company_webpage: '',
        contact_person_first_name: '',
        contact_person_last_name: '',
        city: '',
        bg_number: '',
        database_number: null
      },
      submitted: false
    }
  },
  validations: {
    seller: {
      email: {
        email, 
        required
      },
      phone: {
        required
      },
      organisation_number: {
        required
      },
      contact_person_first_name: {
        required
      },
      contact_person_last_name: {
        required
      },
      company_webpage: {
        required
      },
      company_name: {
        required
      }
    }
  },
  methods: {
    sendForm() {
      this.submitted = true;

      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      let params = {};

      params['company_name'] = this.seller.company_name;
      params['company_webpage'] = this.seller.company_webpage;
      params['company_email'] = this.seller.email;
      params['phone'] = this.seller.phone;
      params['organisation_number'] = this.seller.organisation_number;
      params['contact_person_first_name'] = this.seller.contact_person_first_name;
      params['contact_person_last_name'] = this.seller.contact_person_last_name;
      params['city'] = this.seller.city;
      params['bg_number'] = this.seller.bg_number;
      params['database_number'] = this.seller.database_number;

      this.$store.dispatch(SUBMIT_FORM, params);
    }
  },
  watch: {
    '$store.state.fortnox.fortnox': function () {
      this.seller.company_name = this.$store.getters.name;
      this.seller.organisation_number = this.$store.getters.organizationNumber;
      this.seller.email = this.$store.getters.email;
      this.seller.phone = this.$store.getters.phone;
      this.seller.city = this.$store.getters.city;
      this.seller.bg_number = this.$store.getters.bg;
      this.seller.company_webpage = this.$store.getters.webpage;
      this.seller.contact_person_first_name = this.$store.getters.contactFirstName;
      this.seller.contact_person_last_name = this.$store.getters.contactLastName;
      this.seller.database_number = this.$store.getters.databaseNumber;
    }
  },
  computed: {
    companyEmailApiError: {
        get () {
          return this.$store.getters.companyEmailApiError;
        }
    },
    companyWebpageApiError: {
        get () {
          return this.$store.getters.companyWebpageApiError;
        }
    }
  },
}

</script>
